import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MobilePreviewContextType {
  isMobilePreview: boolean;
  toggleMobilePreview: () => void;
  setMobilePreview: (value: boolean) => void;
}

const MobilePreviewContext = createContext<MobilePreviewContextType | undefined>(undefined);

export const MobilePreviewProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isMobilePreview, setIsMobilePreview] = useState(false);

  const toggleMobilePreview = () => {
    setIsMobilePreview(prev => !prev);
  };

  const setMobilePreview = (value: boolean) => {
    setIsMobilePreview(value);
  };

  return (
    <MobilePreviewContext.Provider
      value={{
        isMobilePreview,
        toggleMobilePreview,
        setMobilePreview,
      }}
    >
      {children}
    </MobilePreviewContext.Provider>
  );
};

export const useMobilePreview = () => {
  const context = useContext(MobilePreviewContext);
  if (context === undefined) {
    throw new Error('useMobilePreview must be used within a MobilePreviewProvider');
  }
  return context;
};
